import React from "react";
import { Card } from "./Card";
import { InfoField } from "./InfoField";

export interface ContextInfoItem {
  label: string;
  value: string | null | undefined;
}

interface ContextInfoCardProps {
  /** Card title */
  title: string;
  /** Array of label-value pairs. Items with falsy values are not rendered. */
  items: ContextInfoItem[];
  /** Number of columns in the grid on medium screens and up. Default: 3 */
  columns?: 1 | 2 | 3 | 4;
}

/**
 * ContextInfoCard
 * Reusable card for displaying contextual read-only info (label-value pairs).
 * Only renders when at least one item has a truthy value.
 */
export const ContextInfoCard: React.FC<ContextInfoCardProps> = ({
  title,
  items,
  columns = 3,
}) => {
  const validItems = items.filter((item) => item.value);

  if (validItems.length === 0) {
    return null;
  }

  const gridColsClass = {
    1: "grid-cols-1",
    2: "grid-cols-1 md:grid-cols-2",
    3: "grid-cols-1 md:grid-cols-3",
    4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
  };

  return (
    <Card variant="formSection">
      <h2 className="text-lg font-medium text-gray-800 mb-4">{title}</h2>
      <div className={`grid ${gridColsClass[columns]} gap-4`}>
        {validItems.map((item) => (
          <InfoField key={item.label} label={item.label} value={item.value} />
        ))}
      </div>
    </Card>
  );
};
